import useSWR from "swr";
import { tutoringPagesTabsData } from "../../../../data/SidebarData";
import { packageUrls } from "../../../../Api/Auth/ApiUrls";
import Breadcrumb from "../../../../Components/Common/Breadcrumb";
import Tabs from "../../../../Components/Common/Tabs";
import StaticPageForm from "../../../../Components/Common/Forms/StaticPageForm";
import { useAuth } from "../../../../Context/AuthContext";
import { one2OneTutoring } from "../../../../Api/Auth/AppUrls";

const MechanicalTutoringIndex = () => {
  const { data } = useSWR(packageUrls.list(""));
  const { userData } = useAuth();
  return (
    <div>
      <Breadcrumb actionButtons={[]} />
      <Tabs
        tabs={
          userData?.roleId === 6
            ? tutoringPagesTabsData.filter(
                (item) => item.path !== one2OneTutoring.purchase
              )
            : tutoringPagesTabsData
        }
      />
      <StaticPageForm
        title="Mechanical Tutoring"
        typeData={data}
        type="packages"
        category="mechanical"
        promo
      />
    </div>
  );
};

export default MechanicalTutoringIndex;
